"use client";

import Link from "next/link";
import { useState } from "react";
import { Check, Silhouette } from "./home-parts";
import s from "./home.module.css";

/* ---------------- Packliste (abhakbar) ---------------- */

export function PackList({ title, items, href }: { title: string; items: string[]; href: string }) {
  const [packed, setPacked] = useState<Record<number, boolean>>({});
  const done = items.filter((_, i) => packed[i]).length;

  return (
    <div className={`${s.toolCard} ${s.rose}`}>
      <div className={s.packHead}>
        <h3 className={s.h3}>Packliste: {title}</h3>
        <span className={s.packCount} aria-live="polite">{done} von {items.length} eingepackt</span>
      </div>
      <div className={s.bar} aria-hidden="true">
        <div className={s.barFill} style={{ width: `${Math.round((done / items.length) * 100)}%` }} />
      </div>
      <div className={s.packList}>
        {items.map((label, i) => {
          const on = !!packed[i];
          return (
            <button key={i} type="button" aria-pressed={on} className={s.packItem}
              onClick={() => setPacked((p) => ({ ...p, [i]: !p[i] }))}>
              <span className={s.packBox}>{on && <Check size={18} stroke="#FFFFFF" width={3} />}</span>
              {label}
            </button>
          );
        })}
      </div>
      <Link href={href} className={s.packLink}>Ganze Packliste zum Abhaken und als PDF →</Link>
    </div>
  );
}

/* ---------------- Alle Guides (mit Kategorie-Filter) ---------------- */

export type Story = { href: string; title: string; tag: string; meta: string; card: string; bg: string; fg: string; photo: React.ReactNode };

export function GuidesSection({ title, stories }: { title: string; stories: Story[] }) {
  const [filter, setFilter] = useState("Alle");
  const tags = [...new Set(stories.map((st) => st.tag))].slice(0, 5);
  const shown = filter === "Alle" ? stories : stories.filter((st) => st.tag === filter);

  return (
    <section id="guides" className={s.section}>
      <div className={s.inner}>
        <div className={`${s.sectionHead} ${s.guidesHead}`}>
          <h2 className={s.h2}>{title}</h2>
          {tags.length > 1 && (
            <div className={s.filters} role="group" aria-label="Guides filtern">
              {["Alle", ...tags].map((c) => (
                <button key={c} type="button" aria-pressed={c === filter} onClick={() => setFilter(c)} className={s.filterBtn}>
                  {c}
                </button>
              ))}
            </div>
          )}
        </div>
        <div className={s.storyGrid}>
          {shown.map((st) => (
            <article key={st.href} className={`lift ${s.story} ${st.card}`}>
              <div className={`ph ${s.storyPhoto}`} style={{ background: st.bg, color: st.fg }}>
                <Silhouette />
                {st.photo}
              </div>
              <div className={s.storyBody}>
                <span className={s.storyTag}>{st.tag}</span>
                <h3 className={s.storyTitle}>
                  <a className={`ttl ${s.storyLink}`} href={st.href}>{st.title}</a>
                </h3>
                <div className={s.storyMeta}>{st.meta}</div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
